import { styled, Tooltip } from '@mui/material'
import { TooltipProps } from '@mui/material/Tooltip/Tooltip'
import * as React from 'react'
import { memo } from 'react'

const Text = styled('span')`
  /* text-decoration: underline;
  text-decoration-style: dotted; */
  cursor: help;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    border-bottom: 1px dashed rgba(149, 164, 173, 1);

    transition: border-color 0.2s ease-in-out;
  }

  &:hover::after {
    border-color: rgba(229, 234, 238, 1);
  }
`

interface TooltipTextProps extends Omit<TooltipProps, 'children'> {
  children: string | React.ReactNode
}
export const TooltipText = memo<TooltipTextProps>((props) => {
  const { children } = props
  return (
    <Tooltip arrow={true} enterDelay={200} {...props}>
      <Text>{children}</Text>
    </Tooltip>
  )
})
